import { MeshBVH } from "three-mesh-bvh";
import * as MeshBVHUtils from "../utils/MeshBVHUtils";

document.addEventListener("DOMContentLoaded", () => {
    AFRAME.registerComponent("trimesh-shape", {
        schema: {
            simplifyModifierReduceFactor: {
                type: "number",
                default: 0.5,
            },
            simplifyModifier: {
                default: false,
            },
            debug: {
                default: false,
            },
            trimSrc: {
                default: "",
            },
            netRemove: {
                default: false,
            },
            updateShape: {
                default: false,
            },
            forcemodel: {
                type: "boolean",
                default: false,
            },
            useBvh: {
                type: "boolean",
                default: true,
            },
        },
        init: function () {
            this.collidableMeshes = [];
            this.collidableGeometrys = [];
            this.glbMesh = null;
            this.groundCannon = this.el;
            this.system = this.el.sceneEl.systems.physics;
            const mesh = this.el.getObject3D("Mesh");
            const loadMesh = async (model) => {
                this.glbMesh = model.scene;
                this.glbMesh.matrixWorldNeedsUpdate = true;
                this.glbMesh.traverse((mesh) => {
                    if (mesh.isMesh) {
                        mesh.matrixWorldNeedsUpdate = true;
                        this.collidableMeshes.push(mesh);
                    }
                });
                this.setShape();
            };
            this.data.forcemodel = false;

            if (!mesh || (this.data.trimSrc && !this.data.forcemodel)) {
                if (this.data.trimSrc && !this.data.forcemodel) {
                    this.el.sceneEl.systems["gltf-system"]
                        .getGLTFLoader()
                        .load(
                            this.data.trimSrc,
                            loadMesh,
                            undefined,
                            (error) => {
                                if (error && error.message) {
                                    console.error(error.message);
                                }
                            }
                        );
                } else {
                    this.el.addEventListener("model-loaded", (event) => {
                        loadMesh(event.detail.model);
                    });
                }
            } else {
                this.el.addEventListener("model-loaded", (event) => {
                    loadMesh(event.detail.model);
                });
            }
        },
        update: function (previousData) {
            this.groundCannon.setAttribute(
                "position",
                this.el.getAttribute("position")
            );
            this.groundCannon.setAttribute(
                "rotation",
                this.el.getAttribute("rotation")
            );
            this.groundCannon.setAttribute(
                "scale",
                this.el.getAttribute("scale")
            );
        },
        setShape: async function () {
            new CANNON.Quaternion().setFromAxisAngle(
                new CANNON.Vec3(-1, 0, 0),
                0
            );
            const scaleFactor = this.el.getAttribute("scale");
            this.el.getAttribute("position");
            this.groundCannon.setAttribute("static-body", "shape", "none");
            this.groundCannon.setAttribute(
                "position",
                this.el.getAttribute("position")
            );
            this.groundCannon.setAttribute(
                "rotation",
                this.el.getAttribute("rotation")
            );
            for (const mesh of this.collidableMeshes) {
                for (const attribute in mesh.attributes) {
                    if (attribute !== "position") {
                        mesh.deleteAttribute(attribute);
                    }
                }
                const geometry = mesh.geometry;
                const index = geometry.getIndex();
                const attributes = geometry.attributes;
                const positionsArray = new Float32Array(
                    3 * attributes.position.count
                );
                for (let i = 0; i < attributes.position.count; ++i) {
                    if (this.collidableMeshes.length) {
                        positionsArray[3 * i + 0] =
                            attributes.position.getX(i) *
                            this.glbMesh.scale.x *
                            scaleFactor.x *
                            mesh.scale.x;
                        positionsArray[3 * i + 1] =
                            attributes.position.getY(i) *
                            this.glbMesh.scale.y *
                            scaleFactor.y *
                            mesh.scale.y;
                        positionsArray[3 * i + 2] =
                            attributes.position.getZ(i) *
                            this.glbMesh.scale.z *
                            scaleFactor.z *
                            mesh.scale.z;
                    } else {
                        positionsArray[3 * i + 0] =
                            attributes.position.getX(i) *
                            this.glbMesh.scale.x *
                            scaleFactor.x;
                        positionsArray[3 * i + 1] =
                            attributes.position.getY(i) *
                            this.glbMesh.scale.y *
                            scaleFactor.y;
                        positionsArray[3 * i + 2] =
                            attributes.position.getZ(i) *
                            this.glbMesh.scale.z *
                            scaleFactor.z;
                    }
                }
                const bufferGeometry = new THREE.BufferGeometry();
                bufferGeometry.setAttribute(
                    "position",
                    new THREE.BufferAttribute(positionsArray, 3)
                );
                bufferGeometry.setIndex(index);

                const simplifiedGeometry = MeshBVHUtils.simplify(
                    bufferGeometry,
                    0.001
                );
                const trimeshShapes = [];

                if (
                    bufferGeometry.getAttribute("position").count > 5000 &&
                    this.data.useBvh
                ) {
                    const bvh = new MeshBVH(simplifiedGeometry, {
                        strategy: 0,
                        maxDepth: 40,
                        maxLeafTris: 1000,
                    });

                    const triangleRanges = [];
                    bvh.shapecast({
                        intersectsBounds: () => true,
                        intersectsRange: (
                            offset,
                            count,
                            contained,
                            depth,
                            nodeIndex
                        ) => {
                            const triangles = [];
                            for (
                                let i = 3 * offset, end = 3 * (offset + count);
                                i < end;
                                i++
                            ) {
                                const index = simplifiedGeometry.index.getX(i);
                                triangles.push(
                                    simplifiedGeometry.attributes.position.getX(
                                        index
                                    ),
                                    simplifiedGeometry.attributes.position.getY(
                                        index
                                    ),
                                    simplifiedGeometry.attributes.position.getZ(
                                        index
                                    )
                                );
                            }
                            triangleRanges.push(triangles);
                        },
                    });

                    simplifiedGeometry.dispose();
                    bufferGeometry.dispose();

                    for (let i = 0, len = triangleRanges.length; i < len; i++) {
                        const triangleArray = new Float32Array(
                            triangleRanges[i]
                        );
                        const trianglesGeometry = new THREE.BufferGeometry();
                        trianglesGeometry.setAttribute(
                            "position",
                            new THREE.BufferAttribute(triangleArray, 3, false)
                        );
                        trianglesGeometry.needsUpdate = true;

                        const optimizedGeometry = MeshBVHUtils.simplify(
                            trianglesGeometry,
                            0.25
                        );
                        const trimesh = new CANNON.Trimesh(
                            optimizedGeometry.getAttribute("position").array,
                            optimizedGeometry.getIndex().array
                        );

                        trimesh.updateBoundingSphereRadius();
                        trimeshShapes.push(trimesh);

                        optimizedGeometry.dispose();
                        trianglesGeometry.dispose();
                    }
                } else {
                    const optimizedGeometry = MeshBVHUtils.simplify(
                        simplifiedGeometry,
                        0.55
                    );
                    const trimesh = new CANNON.Trimesh(
                        optimizedGeometry.getAttribute("position").array,
                        optimizedGeometry.getIndex().array
                    );

                    trimesh.updateBoundingSphereRadius();
                    trimeshShapes.push(trimesh);
                }

                const staticBodyComponent =
                    this.groundCannon.components["static-body"];

                if (staticBodyComponent.body) {
                    const boundingBoxHelper =
                        new THREE.BoxHelper().setFromObject(
                            this.glbMesh,
                            16776960
                        );
                    let positionOffset = new CANNON.Vec3(0, 0, 0);
                    boundingBoxHelper.update();
                    boundingBoxHelper.geometry.computeBoundingBox();
                    const boundingBox = new THREE.Box3().setFromObject(
                        this.glbMesh
                    );
                    positionOffset = this.collidableMeshes.length
                        ? new CANNON.Vec3(
                              boundingBox.min.x * scaleFactor.x,
                              boundingBox.min.y * scaleFactor.y,
                              boundingBox.min.z * scaleFactor.z
                          )
                        : new CANNON.Vec3(
                              this.glbMesh.position.x *
                                  scaleFactor.x *
                                  this.glbMesh.scale.x,
                              this.glbMesh.position.y *
                                  scaleFactor.y *
                                  this.glbMesh.scale.y,
                              this.glbMesh.position.z *
                                  scaleFactor.z *
                                  this.glbMesh.scale.z
                          );

                    for (let i = 0, len = trimeshShapes.length; i < len; i++) {
                        staticBodyComponent.addShape(
                            trimeshShapes[i],
                            positionOffset
                        );
                    }

                    trimeshShapes.length = 0;
                }

                this.groundCannon.addEventListener("body-init", (event) => {
                    const staticBodyComponent =
                        this.groundCannon.components["static-body"];
                    const positionOffset = new CANNON.Vec3(
                        this.glbMesh.position.x * scaleFactor.x,
                        this.glbMesh.position.y * scaleFactor.y,
                        this.glbMesh.position.z * scaleFactor.z
                    );
                    staticBodyComponent.addShape(
                        trimeshShapes[0],
                        positionOffset
                    );
                });
            }
        },

        remove() {
            if (this.groundCannon.components["static-body"].body) {
                this.system.removeBody(
                    this.groundCannon.components["static-body"].body
                );
            }

            if (this.el.body) {
                delete this.el.body;
            }

            this.groundCannon.removeAttribute("static-body");
        },
    });
});
